import React from 'react';
import styles from './markdown.module.css';

// React already escapes text in JSX expressions ({string}) — re-escaping here
// renders entities literally (e.g. &quot; shows as the 6 chars instead of ").

function renderInline(text: string): React.ReactNode[] {
  const parts: React.ReactNode[] = [];
  const boldRegex = /\*\*(.*?)\*\*/g;
  let lastIndex = 0;
  let match;
  let key = 0;

  while ((match = boldRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(<span key={key++}>{text.slice(lastIndex, match.index)}</span>);
    }
    parts.push(<strong key={key++}>{match[1]}</strong>);
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(<span key={key++}>{text.slice(lastIndex)}</span>);
  }

  return parts.length > 0 ? parts : [<span key={0}>{text}</span>];
}

export function renderSafeMarkdown(text: string): React.ReactNode[] {
  const lines = text.split('\n');
  return lines.map((line, i) => {
    if (line.trim() === '') return <br key={i} />;

    if (line.trim().startsWith('- ') || line.trim().startsWith('• ')) {
      const content = line.replace(/^[\s]*[-•]\s*/, '');
      return (
        <p key={i} className={styles.listItem}>
          <span className={styles.bullet}>•</span>
          <span>{renderInline(content)}</span>
        </p>
      );
    }

    return <p key={i} className={styles.paragraph}>{renderInline(line)}</p>;
  });
}
